/**
 * Created by piotr.pozniak@thebeaverhead.com on 05/04/2022.
 */

const initialState = {
  collection: [],

  fetch: false,
  fetchError: null,
  fetchSuccess: null,

  updateGroupUUID: "",
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "GROUPS_FETCH":
      return {
        ...state,
        fetch: true,
      };

    case "GROUPS_FETCH_FULFILLED":
      return {
        ...state,
        collection: action.payload,
        fetch: false,
        fetchSuccess: true,
        fetchError: false,
      };

    case "GROUPS_FETCH_REJECTED":
      return {
        ...state,
        fetch: false,
        fetchSuccess: false,
        fetchError: true,
      };

    case "GROUP_UPDATE":
      return {
        ...state,
        updateGroupUUID: action.payload.groupUUID,
      };

    case "GROUP_UPDATE_REJECTED":
      return {
        ...state,
        updateGroupUUID: "",
      };

    case "GROUP_UPDATE_FULFILLED":
      const groupIdx = state.collection.findIndex(
        (i) => i.uuid == action.payload.uuid
      );

      if (groupIdx >= 0) {
        state.collection.splice(groupIdx, 1, action.payload);
      } else {
        state.collection.unshift(action.payload);
      }

      return {
        ...state,
        collection: state.collection,
        updateGroupUUID: "",
      };

    case "GROUP_DELETE":
      return {
        ...state,
        updateGroupUUID: action.payload.groupUUID,
      };

    case "GROUP_DELETE_FULFILLED":
      return {
        ...state,
        collection: state.collection.filter(
          (i) => i.uuid != action.payload.uuid
        ),
        updateGroupUUID: "",
      };

    case "GROUP_DELETE_REJECTED":
      return {
        ...state,
        updateGroupUUID: "",
      };

    case "USER_LOGOUT":
      return { ...initialState, collection: [] };

    default:
      return state;
  }

  return state;
}
